/* istanbul ignore file */
import { Box, Input } from '@chakra-ui/react';
import React, { useContext } from 'react';
import { DataTableContext } from '..';
import { InputGroup } from '@/components/ui/input-group';
import { Search as SearchIcon } from 'react-feather';

export const TableSearch = () => {
  const { tableProps: props } = useContext(DataTableContext);
  const { showSearch, onSearch, setSelectedRows } = props;
  const { styles } = props;
  if (!showSearch) {
    return null;
  }

  const handleSearch = (evt: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedRows?.([]);

    if (!onSearch) {
      return;
    }
    onSearch(evt);
  };
  return (
    <Box css={styles.search}>
      <InputGroup width="100%" height="43px" startElement={<SearchIcon size={18} />}>
        <Input
          type="text"
          pl={3}
          fontSize="sm"
          placeholder="Search"
          onChange={handleSearch}
          _placeholder={{ textStyle: 'caption', opacity: 1 }}
        />
      </InputGroup>
    </Box>
  );
};
